<div class="main_wp enq_listing pikdrop_enq enq_dtl_card noscroll">
  <div class="conta_iner sp_auctions_bids">
    <div
      class="main_box"
      infiniteScroll
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="50"
      [scrollWindow]="false"
      (scrolled)="onScrollingFinished()">
      @if (loading() === false) {
        @if (auctions().length > 0) {
          @if (userProfile) {
            <div
              class="column_container"
              [ngClass]="{ two_li: auctions().length > 1 }">
              <logibids-enquiry-card
                [auctions]="auctions()"
                [auctionType]="auctionType()"
                [userProfile]="userProfile"
                source="driverEnquiry"
                (bidPlaced)="handleBidPlaced()"
                (auctionAccepted)="handleAuctionAccepted()">
              </logibids-enquiry-card>
            </div>
          }
        } @else {
          <div class="container noDataFound mt-3">
            <figure>
              <img
                [ngSrc]="assetsConst.noEnqueries"
                alt="noEnq"
                width="315"
                height="224"
                priority />
            </figure>
            <p class="text-center">{{ 'noEnquiriesFound' | translate }}</p>
          </div>
        }
      }
    </div>
  </div>
</div>

<ngx-ui-loader
  loaderId="driver-loader"
  [overlayColor]="'rgba(255,255,255,0.8)'"
  [bgsOpacity]="1"
  [fgsType]="'circle'"
  [fgsColor]="'#000000'"
  [pbColor]="'#000000'"
  [hasProgressBar]="false"
  [text]="''"></ngx-ui-loader>
